import type { MentionUser } from "@/domains/pm/components/issues/MentionTextarea";
import type { MentionAudienceUser } from "@/stores/documents/comments/types";

/** Same rule as the picker and the highlighter: full name, else email. */
export function mentionDisplayName(user: MentionAudienceUser | MentionUser): string {
  const full = `${user.first_name ?? ""} ${user.last_name ?? ""}`.trim();
  return full || user.email;
}

export function mentionDisplayNames(users: MentionAudienceUser[]): string[] {
  return users.map(mentionDisplayName).filter((n) => n.length > 0);
}

/**
 * The mentioned user ids implied by a body, resolved against the SAME audience
 * the picker offers — so an edit keeps or drops mentions to match the final
 * text, and a name typed for someone outside the audience mentions nobody.
 */
export function deriveMentionIds(text: string, users: MentionAudienceUser[]): number[] {
  const ids: number[] = [];
  for (const u of users) {
    const name = mentionDisplayName(u);
    if (name && text.includes(`@${name}`)) ids.push(u.id);
  }
  return ids;
}

export function toMentionUsers(users: MentionAudienceUser[]): MentionUser[] {
  return users.map((u) => ({
    id: u.id,
    first_name: u.first_name,
    last_name: u.last_name,
    email: u.email,
    avatar_url: u.avatar_url,
    color: u.color,
  }));
}
